document.addEventListener('click', function (event) {
  const wishlistButton = event.target.closest?.(
    'wishlist-button-collection, wishlist-button-product'
  );

  if (!wishlistButton) return;

  const headerHeart = document.querySelector(
    '.header__icon--wishlist .icon-wishlist'
  );

  if (!headerHeart) return;

  headerHeart.classList.remove('is-heartbeating');
  void headerHeart.offsetWidth;
  headerHeart.classList.add('is-heartbeating');

  headerHeart.addEventListener('animationend', function handleEnd() {
    headerHeart.classList.remove('is-heartbeating');
    headerHeart.removeEventListener('animationend', handleEnd);
  });
});